import React from 'react';
import styled from 'styled-components';
import { IoSearchSharp } from 'react-icons/io5';

import { CredusButton, CredusText, color } from 'ui';
import { FunnelIcon } from '../../../assets/images/svgs';

interface ReportFilterProps {
  selectedRowKeys: React.Key[];
  // eslint-disable-next-line no-unused-vars
  handleSearch: (text: string) => void;
  searchText: string;
  setXport: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReportFilterForm = ({
  selectedRowKeys,
  searchText,
  handleSearch,
  setXport,
}: ReportFilterProps) => {
  const hasSelected = selectedRowKeys.length > 0;
  const handleExportText = () => {
    setXport(true);
  };

  return (
    <Container>
      <SearchDiv>
        <Input
          value={searchText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleSearch(e.target.value)
          }
          placeholder="Try searching for information"
        />
        <IoSearchSharp color="#C3CAD9" />
      </SearchDiv>
      <FilterDiv>
        <CredusText weight="medium" size="sm" color={color.black}>
          Filter by
        </CredusText>
        <DivAll>
          <CredusText weight="medium" size="sm" color={color.black}>
            All
          </CredusText>
          <FunnelIcon />
        </DivAll>
        <CredusButton onClick={handleExportText} variant="secondary">
          Export
        </CredusButton>
        <BatchButtonWrap disabled={!hasSelected} variant="primary" size="small">
          Batch Upload
        </BatchButtonWrap>
      </FilterDiv>
    </Container>
  );
};

export default ReportFilterForm;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const SearchDiv = styled.div`
  width: 326px;
  height: 36px;
  background: ${color.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border: 1px solid rgba(38, 50, 56, 0.03);
  box-shadow: 0px 2px 5px rgba(38, 51, 77, 0.03);
`;

const Input = styled.input`
  outline: none;
  border: none;
  width: 90%;
  &::placeholder {
    color: #adb8cc;
  }
`;

const FilterDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const DivAll = styled.div`
  background: ${color.white};
  gap: 0.43rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.56rem 1.25rem;
  border: 0.709924px solid #e0def7;
  border-radius: 8.51908px;
  cursor: pointer;
`;

const BatchButtonWrap = styled(CredusButton)`
  &:disabled {
    background: #fb0200;
    opacity: 0.5;
  }
`;
